import {getNotifications, readAllNotifications, sendNotification} from "@/api/notification";

const blankNotification = {
  color: 'success',
  note: '',
  types: {
    notification: false,
    email: false,
    telegram: false,
  },
  url: {
    enable: false,
    link: '/change-log'
  },
  email_affiliate_ids: [],
  notification_affiliate_ids: [],
  email_affiliates_all: false,
  notification_affiliates_all: false,
}

export default {
  namespaced: true,
  state: {
    notifications: [],
    notificationModal: {
      visible: false,
      notification: null
    },
  },
  getters: {
    notifications: state => state.notifications,
    notificationModal: state => state.notificationModal,
  },
  mutations: {
    UPDATE_NOTIFICATION_MODAL_VISIBLE(state, visible) {
      state.notificationModal.visible = visible
    },
    SHOW_MODAL(state) {
      state.notificationModal = {
        visible: true,
        notification: JSON.parse(JSON.stringify(blankNotification))
      }
    },
    SET_NOTIFICATIONS(state, val){
      state.notifications = val
    },
    READ_ALL_NOTIFICATIONS(state){
      state.notifications.forEach(i => i.read_at = new Date())
    }
  },
  actions: {
    sendNotification({state, commit, rootState}) {
      return new Promise((resolve, reject) => {
        sendNotification(state.notificationModal.notification)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    getNotifications({commit}){
      getNotifications().then(response => {
        commit('SET_NOTIFICATIONS', response)
      })
    },
    readAllNotifications({commit}){
      readAllNotifications().then(response => {
        commit('READ_ALL_NOTIFICATIONS')
      })
    }
  },
}
